export const recipesRetiredCopy = {
    noticeTitle: 'Recipes have been replaced by Segments',
    noticeBody:
        'You can no longer create new recipes. Your existing recipes keep running and you can still edit them. For new automation, create a Segment.',
    createSegment: 'Create a Segment',
    goToSegments: 'Go to Segments',
    duplicateDisabled:
        'Recipes can no longer be duplicated. Upgrade this recipe to a Segment, then duplicate the Segment.',
}
